module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Db-Ga-Ha-Ia.0db1a269.png";